import React, {useEffect, useState} from 'react';
import Message from './Message.js';
import Api from "../../Api.js";
import {useParams} from "react-router-dom";
import {useSelector} from "react-redux";


const MessageList = ({message, setMessage, }) => {
    const [seeMoreSms, setSeeMoreSms] = useState(true);
    const {id} = useParams()
    const login = useSelector((state) => state.manager.employee);

    useEffect(() => {
        (async () => {
            await fetchTaskSms(0);
        })()
    }, [id]);

    const fetchTaskSms = async (startIndex) => {
        const {data} = await Api.getSurveyMessage(id, {
            start_index: startIndex,
            for_all: null,
        })
        setMessage(data)
    };

    const handleScroll = async (e) => {
        const {scrollTop, scrollHeight, clientHeight} = e.target;

        if (scrollHeight - scrollTop <= clientHeight + 1) {
            if (message.length % 10 === 0) {
                await fetchTaskSms(message.length);
                console.log('Scrolled to bottom, fetching more...');
            }
        }
    };


    return (
        <div className="message-list" onScroll={handleScroll}>
            {message.map((item, index) => {
                const isMine = item.sender.id === login.user_id;
                return <Message key={index} data={item} isMine={isMine}/>;
            })}
            {message.length % 10 === 0 && seeMoreSms && (
                <div className="see-more-sms" onClick={() => fetchTaskSms(message.length)}>
                    Տեսնել ավելին
                </div>
            )}
        </div>
    );
};

export default MessageList;
